import { Spin } from "antd";
import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        background: "#f3f4f6",
      }}
    >
      <Spin size="large" tip="Loading dashboard...">
        <div style={{ minHeight: 80 }} />
      </Spin>
    </div>
  );
};

export default LoadingSpinner;
